import { cx } from './cx';

export type AvatarSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';
/** Teintes d'accompagnement pour distinguer des personnes (ex. moniteurs). */
export type AvatarTint = 'indigo' | 'blue' | 'amber' | 'green';

const sizes: Record<AvatarSize, string> = {
  xs: 'h-5 w-5 text-[9px]',
  sm: 'h-8 w-8 text-xs',
  md: 'h-10 w-10 text-[13px]',
  lg: 'h-12 w-12 text-base',
  xl: 'h-[68px] w-[68px] text-2xl tracking-[-1px] ring-4 ring-white shadow-card',
};

const tints: Record<AvatarTint, string> = {
  indigo: 'bg-avatar text-primary-700',
  blue: 'bg-blue-100 text-blue-800',
  amber: 'bg-amber-100 text-warn-fg',
  green: 'bg-success-light text-success-dark',
};

/** Initiales à partir d'un nom complet (« Léa Martin » → « LM »). */
export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const letters = parts.length > 1 ? parts[0][0] + parts[parts.length - 1][0] : (parts[0] ?? '').slice(0, 2);
  return letters.toUpperCase();
}

interface AvatarProps {
  name: string;
  size?: AvatarSize;
  tint?: AvatarTint;
  src?: string;
  className?: string;
}

export function Avatar({ name, size = 'md', tint = 'indigo', src, className }: AvatarProps) {
  return (
    <span
      className={cx(
        'relative grid shrink-0 place-items-center overflow-hidden rounded-full font-semibold',
        sizes[size],
        tints[tint],
        className,
      )}
      title={name}
    >
      {src ? <img src={src} alt="" className="h-full w-full object-cover" /> : <span aria-hidden>{initials(name)}</span>}
      <span className="sr-only">{name}</span>
    </span>
  );
}
